<template>
  <v-container>
    <v-card>
      <v-img
        :src="user.image || defaultImage"
        height="300"
        class="mb-3"
      ></v-img>
      <v-card-title>{{ user.fullName }}</v-card-title>
      <v-card-subtitle>{{ user.title }}</v-card-subtitle>
      <v-card-text>
        <p><strong>Email:</strong> {{ user.email }}</p>
        <p><strong>Phone:</strong> {{ user.phoneNumber }}</p>
        <p><strong>Gender:</strong> {{ user.gender }}</p>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" text>Connect</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/firebase";

export default {
  data() {
    return {
      user: {},
      defaultImage: "@/assets/default-user.png", // Default user image path
    };
  },
  methods: {
    async fetchUser() {
      try {
        const userId = this.$route.params.id;
        const userRef = doc(db, "user", userId);
        const userSnapshot = await getDoc(userRef);

        if (userSnapshot.exists()) {
          this.user = userSnapshot.data();
        } else {
          console.error("User not found.");
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    },
  },
  async mounted() {
    await this.fetchUser();
  },
};
</script>
